<template>
  <b-modal
    modal-class="component-modal-product"
    id="productHistoryItemModal"
    ref="productHistoryItemModal"
    size="xl"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
    hide-footer
    scrollable
  >
    <b-table
      id="productHistoryTable"
      ref="productHistoryTable"
      hover
      small
      sort-icon-left
      head-variant="light"
      :items="productHistoryData"
      :fields="fields"
      :filter="filter"
      :sort-desc="true"
      :responsive="true"
    >
      <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>

      <template v-slot:cell(adjustQtyStock)="row">
        {{ formatAdjustQty(row.value) }}
      </template>
    </b-table>

    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import moment from "moment";

export default {
  name: "ProductHistoryItemModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "ประวัติการจัดการสต๊อก",
      productHistoryData: [],
      productUnit: "",
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "4%", padding: "8px" },
          tdStyle: { width: "4%", padding: "8px" },
        },
        {
          key: "detailStock",
          label: "รายละเอียดการจัดการ",
          thStyle: { width: "22%", padding: "8px" },
          tdStyle: { width: "22%", padding: "8px" },
        },
        {
          key: "reasonStock",
          label: "เหตุผล",
          thStyle: { width: "22%", padding: "8px" },
          tdStyle: { width: "22%", padding: "8px" },
        },
        {
          key: "managedByStock",
          label: "จัดการโดย",
          thStyle: { width: "18%", padding: "8px" },
          tdStyle: { width: "18%", padding: "8px" },
        },
        {
          key: "dateTimeStock",
          label: "วัน เวลาที่จัดการ",
          thStyle: { width: "12%", padding: "8px" },
          tdStyle: { width: "12%", padding: "8px" },
        },
        {
          key: "adjustQtyStock",
          label: "จำนวนปรับปรุง",
          thStyle: { width: "13%", padding: "8px" },
          tdStyle: { width: "13%", padding: "8px" },
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "unitStock",
          label: "หน่วยสินค้า",
          thStyle: { width: "9%", padding: "8px" },
          tdStyle: { width: "9%", padding: "8px" },
          tdClass: "text-wrap-cell",
        },
      ],
      filter: null,
    };
  },
  methods: {
    show(data) {
      const { historyData, productUnit } = data;
      this.productUnit = productUnit;
      this.adjustProductHistoryData(historyData);
      this.$bvModal.show("productHistoryItemModal");
    },
    close() {
      this.$bvModal.hide("productHistoryItemModal");
    },
    adjustProductHistoryData(data) {
      this.productHistoryData = data.map(item => {
        const detailAndReason = this.mapProductHistoryDetail(item);
        return {
          detailStock: detailAndReason.detailStock,
          reasonStock: detailAndReason.reasonStock,
          managedByStock: this.formatName(item.creationUser),
          dateTimeStock: this.formatDate(item.creationDt),
          adjustQtyStock: item.qtyBaseUom,
          unitStock: this.productUnit,
        };
      });
    },
    formatName(name) {
      return `${name.firstNameTh} ${name.lastNameTh}`;
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY HH:mm");
      } else {
        return "";
      }
    },
    mapProductHistoryDetail(data) {
      const detailType = data.docType;
      const doc = data.doc;

      switch (detailType) {
        case "ADJUSTMENT":
          return this.getAdjustmentDetail(data, doc);

        case "TREATMENT":
          return {
            detailStock: "สินค้าถูกใช้งาน ผ่านการรักษา",
            reasonStock: "-",
          };

        case "GOOD_RECEIVE":
          return {
            detailStock: "รับสินค้าเข้าผ่านใบรับสินค้า",
            reasonStock: "-",
          };

        case "TRANSFER":
          return this.getTransferDetail(data, doc);

        default:
          return {
            detailStock: "-",
            reasonStock: "-",
          };
      }
    },
    getTransferDetail(data, doc) {
      const isOut = data.branchId === doc.fromBranchId;
      return {
        detailStock: isOut ? "โอนสินค้าออก" : "รับโอนสินค้าเข้า",
        reasonStock: doc.reason || "-",
      };
    },
    getAdjustmentDetail(data, doc) {
      if (doc.type === "GENERAL") {
        return {
          detailStock: "ปรับปรุงทั่วไป",
          reasonStock: doc.reason || "-",
        };
      }
      if (doc.type === "RETURN") {
        return {
          detailStock: "ส่งคืนสินค้า",
          reasonStock: doc.reason || "-",
        };
      } else if (doc.type === "PHYSICAL_COUNT") {
        return {
          detailStock: "ตรวจนับสต๊อก",
          reasonStock: doc.reason || "-",
        };
      }
    },
    formatAdjustQty(value) {
      if (value === null || value === "") return "";
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      const formatted = num.toLocaleString("en-US");
      if (num > 0) return `+${formatted}`;
      return formatted;
    },
  },
};
</script>

<style scoped>
::v-deep #productHistoryTable thead tr th,
::v-deep #productHistoryTable tbody tr td {
  vertical-align: middle !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

::v-deep #productHistoryTable td.text-wrap-cell {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
